const initialState = {
  subscribersList: []
};

export const subscribersReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "subscribers")
    return action.execute(state);
  return state;
};
